import createIcon from '../../createIcon';

/**
 * @component @name ElectricMeter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM3LjA0IDIgMyA2LjA0IDMgMTFDMyAxNC45MSA1LjUxIDE4LjI0IDkgMTkuNDdWMjJIMTFWMTkuOTRDMTEuMzMgMTkuOTggMTEuNjYgMjAgMTIgMjBDMTIuMzQgMjAgMTIuNjcgMTkuOTggMTMgMTkuOTRWMjJIMTVWMTkuNDdDMTguNDkgMTguMjMgMjEgMTQuOSAyMSAxMUMyMSA2LjA0IDE2Ljk2IDIgMTIgMlpNMTQuMjUgMTRMMTEuMjUgMTdMOS43NSAxNS41TDExIDE0LjI1TDkuNzUgMTNMMTIuNzUgMTBMMTQuMjUgMTEuNUwxMyAxMi43NUwxNC4yNSAxNFpNMTYgOUg4VjdIMTZWOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ElectricMeter = createIcon('ElectricMeter', [
  [
    'path',
    {
      d: 'M12 2C7.04 2 3 6.04 3 11C3 14.91 5.51 18.24 9 19.47V22H11V19.94C11.33 19.98 11.66 20 12 20C12.34 20 12.67 19.98 13 19.94V22H15V19.47C18.49 18.23 21 14.9 21 11C21 6.04 16.96 2 12 2ZM14.25 14L11.25 17L9.75 15.5L11 14.25L9.75 13L12.75 10L14.25 11.5L13 12.75L14.25 14ZM16 9H8V7H16V9Z',
      key: '1wi66u',
    },
  ],
]);

export default ElectricMeter;
